<template>
  <div class="mt-6">
    <Modal
        :title="itemForTerminate && (itemForTerminate.credential === thisDevice.credential) ? $t('message.this device') : $t('message.terminate')"
        labelClass="btn-outline-warning"
        ref="modal5"
        themeClass="bg-warning-500"
        :hasButton="false"
        :activeModal="isShowTerminateModal"
        @closeModal="closeModal"
        centered
    >
      <div class="text-base mb-3 text-slate-600 dark:text-slate-300 text-center">
        {{
          itemForTerminate && (itemForTerminate.credential === thisDevice.credential) ? $t('message.terminate current device') : $t('message.terminate') + " " + $t('message.device')
        }}
      </div>
      <div class="flex-1 text-center mb-3">
        <span class="block text-sm text-slate-900 dark:text-slate-300">
          {{
            itemForTerminate.appName === "Rifen" || itemForTerminate.appName === "Rifen Manager" ? $t('message.' + (itemForTerminate.appName)) + " " : itemForTerminate.appName + " "
          }}
          {{
            $t('message.' + (itemForTerminate.platform)) + " "
          }}
          {{ itemForTerminate.version }}
        </span>
        <span class="block font-normal text-xs text-slate-700 dark:text-slate-400 mt-2">
          {{ $t('message.ip address') }}: {{ itemForTerminate.ipAddress }}
        </span>
        <div class="mt-2">
          <span class="font-normal text-xs text-slate-700 dark:text-slate-400 order-first">
            {{ itemForTerminate.country ? $t('countries.' + (itemForTerminate.country)) : itemForTerminate.country }}
          </span>
          &#8226;
          <span class="font-normal text-xs text-slate-700 dark:text-slate-400">
            {{ getFormattedDate(itemForTerminate.lastUpdate) }}
          </span>
        </div>
      </div>
      <h4 class="font-medium text-lg text-slate-900 text-center">
        {{ $t('message.are you sure?') }}
      </h4>
      <template v-slot:footer>
        <div class="flex flex-row justify-center align-center w-full space-x-3 rtl:space-x-reverse">
          <Button
              :text="$t('message.close')"
              btnClass="btn-outline-dark "
              @click="()=>{closeModal()}"
          />
          <button @click="terminateSession"
                  class="btn btn-warning block text-center flex items-center justify-center gap-3">
            {{ $t('message.terminate') }}
            <Icon v-show="loading" icon="eos-icons:bubble-loading" height="24"/>
          </button>
        </div>
      </template>
    </Modal>
    <skeleton v-if="loading" :title="$t('message.this device')"></skeleton>
    <div v-else-if="Object.keys(thisDevice).length" class="xl:col-span-4 lg:col-span-5 col-span-12 mb-5">
      <Card :title="$t('message.this device')">
        <ul class="divide-y divide-slate-100 dark:divide-slate-700">
          <li class="block py-[8px]">
            <div class="flex space-x-2 rtl:space-x-reverse">
              <div class="flex-1 flex space-x-2 rtl:space-x-reverse">
                <div class="flex-none">
                  <div class="h-8 w-8">
                    <img
                        v-if="themeSettingsStore.isDark"
                        src="@/assets/images/icon/devices-white.png"
                        alt=""
                        class="block w-full h-full object-cover border border-transparent"
                    />
                    <img
                        v-else
                        src="@/assets/images/icon/devices-black.png"
                        alt=""
                        class="block w-full h-full object-cover border border-transparent"
                    />
                  </div>
                </div>
                <div class="flex-1">
                  <span class="block text-sm text-slate-900 dark:text-slate-300">
                    {{
                      thisDevice.appName === "Rifen" || thisDevice.appName === "Rifen Manager" ? $t('message.' + (thisDevice.appName)) + " " : thisDevice.appName + " "
                    }}
                    {{
                      $t('message.' + (thisDevice.platform)) + " "
                    }}
                    {{ thisDevice.version ? thisDevice.version : '' }}
                  </span>
                  <span class="block font-normal text-xs text-slate-700 dark:text-slate-400 mt-2">
                    {{ $t('message.ip address') }}: {{ thisDevice.ipAddress }}
                  </span>
                  <div class="mt-2">
                    <span class="font-normal text-xs text-slate-700 dark:text-slate-400 order-first">
                      {{ thisDevice.country ? $t('countries.' + (thisDevice.country)) : thisDevice.country }}
                    </span>
                    &#8226;
                    <span class="font-normal text-xs text-slate-700 dark:text-slate-400">
                      {{ getFormattedDate(thisDevice.lastUpdate) }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="flex-none">
                <button @click="terminateModal(thisDevice)"
                        type="button"
                        class="text-xs text-slate-900 dark:text-white"
                >
                  {{ $t('message.terminate') }}
                </button>
              </div>
            </div>
          </li>
        </ul>
      </Card>
    </div>
    <skeleton v-if="loading" :title="$t('message.connected devices')"></skeleton>
    <div v-else-if="activeSessions.length > 0" class="xl:col-span-4 lg:col-span-5 col-span-12">
      <Card :title="$t('message.connected devices')">
        <ul class="divide-y divide-slate-100 dark:divide-slate-700">
          <li v-for="(item, i) in activeSessions" :key="i" class="block py-[8px]">
            <div class="flex space-x-2 rtl:space-x-reverse">
              <div class="flex-1 flex space-x-2 rtl:space-x-reverse">
                <div class="flex-none">
                  <div class="h-8 w-8">
                    <img
                        v-if="themeSettingsStore.isDark"
                        src="@/assets/images/icon/devices-white.png"
                        alt=""
                        class="block w-full h-full object-cover border border-transparent"
                    />
                    <img
                        v-else
                        src="@/assets/images/icon/devices-black.png"
                        alt=""
                        class="block w-full h-full object-cover border border-transparent"
                    />
                  </div>
                </div>
                <div class="flex-1">
                  <span class="block text-sm text-slate-900 dark:text-slate-300">
                    {{
                      item.appName === "Rifen" || item.appName === "Rifen Manager" ? $t('message.' + (item.appName)) + " " : item.appName + " "
                    }}
                    {{
                      $t('message.' + (item.platform)) + " "
                    }}
                    {{ item.version }}
                  </span>
                  <span class="block font-normal text-xs text-slate-700 dark:text-slate-400 mt-2">
                    {{ $t('message.ip address') }}: {{ item.ipAddress }}
                  </span>
                  <div class="mt-2">
                    <span class="font-normal text-xs text-slate-700 dark:text-slate-400">
                      {{ item.country ? $t('countries.' + (item.country)) : item.country }}
                    </span>
                    &#8226;
                    <span class="font-normal text-xs text-slate-700 dark:text-slate-400">
                      {{ getFormattedDate(item.lastUpdate) }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="flex-none">
                <button @click="terminateModal(item)"
                        type="button"
                        class="text-xs text-slate-900 dark:text-white"
                >
                  {{ $t('message.terminate') }}
                </button>
              </div>
            </div>
          </li>
        </ul>
      </Card>
    </div>
  </div>
</template>

<script>
import {useUserStore} from "@/stores/user";
import {computed, onMounted, ref} from "vue";
import Icon from "@/components/Icon/index.vue";
import Card from "@/components/Card/index.vue";
import Checkbox from "@/components/Checkbox/index.vue";
import Modal from "@/components/Modal/Modal.vue";
import Button from "@/components/Button/index.vue";
import {useToast} from "vue-toastification";
import jalaliMoment from 'jalali-moment';
import {useI18n} from 'vue-i18n';
import skeleton from "@/components/Skeleton/Session.vue"
import {useThemeSettingsStore} from "@/stores/themeSettings.js";

export default {
  name: "sessions",
  components: {
    Icon,
    Card,
    Checkbox,
    Modal,
    Button,
    skeleton
  },
  setup() {
    const activeSessions = ref([])
    const thisDevice = ref({});
    const userStore = useUserStore();
    const loading = ref(true);
    const isShowTerminateModal = ref(false);
    const itemForTerminate = ref(null);
    const terminated = ref(null);
    const toast = useToast();
    const {locale} = useI18n({useScope: 'global'})
    const themeSettingsStore = useThemeSettingsStore()
    async function getActiveSessions() {
      loading.value = true;
      await userStore.action_getActiveSessions()
      activeSessions.value = userStore.getActiveSessions;
      thisDevice.value = activeSessions.value.find(({credential}) => credential === userStore.getCredential);
      activeSessions.value = activeSessions.value.filter(object => {
        return object.credential !== userStore.getCredential;
      });
      //console.log(thisDevice.value)
      loading.value = false;
    }
    function terminateModal(item) {
      itemForTerminate.value = item;
      isShowTerminateModal.value = true;
    }

    const message = computed(() => {
      return userStore.getErrorMessage;
    });
    function closeModal() {
      isShowTerminateModal.value = false;
    }
    async function terminateSession() {
      //console.log("itemForTerminate: ", itemForTerminate.value)
      terminated.value = await userStore.action_terminateSession({credential: itemForTerminate.value.credential})
      //console.log("terminated: ", terminated.value)
      if (terminated.value) {
        await getActiveSessions();
        isShowTerminateModal.value = false;
        toast.success("Terminated successfully", {
          timeout: 2000,
        });
      } else {
        isShowTerminateModal.value = false;
        toast.error(message.value);
      }
    }

    onMounted(() => {
      getActiveSessions();
    })
    const getFormattedDate = (timestamp) => {
      const currentDate = new Date();
      const date = new Date(timestamp);
      const jalaliDate = jalaliMoment(date);

      const currentLocale = locale.value || 'en'; // Use the current locale from Vue I18n or default to 'en-US'

      if (isSameDay(currentDate, date)) {
        return currentLocale === 'fa'
            ? `امروز ${jalaliDate.locale('fa').format('HH:mm')}`
            : `Today ${jalaliDate.format('HH:mm')}`;
      } else if (isYesterday(currentDate, date)) {
        return currentLocale === 'fa'
            ? `دیروز ${jalaliDate.locale('fa').format('HH:mm')}`
            : `Yesterday ${jalaliDate.format('HH:mm')}`;
      } else if (isSameWeek(currentDate, date)) {
        return currentLocale === 'fa'
            ? `${jalaliDate.locale('fa').format('dddd HH:mm')}`
            : `${jalaliDate.format('dddd HH:mm')}`;
      } else {
        return currentLocale === 'fa'
            ? jalaliDate.locale('fa').format('HH:mm - jYYYY/jMM/jDD')
            : jalaliDate.format('YYYY/MM/DD - HH:mm');
      }
    };
    const isSameDay = (date1, date2) => {
      return (
          date1.getDate() === date2.getDate() &&
          date1.getMonth() === date2.getMonth() &&
          date1.getFullYear() === date2.getFullYear()
      );
    };
    const isYesterday = (date1, date2) => {
      const yesterday = new Date(date1);
      yesterday.setDate(date1.getDate() - 1);
      return isSameDay(yesterday, date2);
    };
    const isSameWeek = (date1, date2) => {
      const oneDayMilliseconds = 24 * 60 * 60 * 1000;
      const diffInDays = Math.abs((date1 - date2) / oneDayMilliseconds);
      const diffInWeeks = diffInDays / 7;
      return diffInWeeks <= 1;
    };

    return {
      activeSessions,
      loading,
      thisDevice,
      isShowTerminateModal,
      terminateSession,
      terminateModal,
      itemForTerminate,
      closeModal,
      locale,
      getFormattedDate,
      themeSettingsStore
    }
  }
}
</script>

<style scoped>

</style>
